import imgPDF1 from './assets/1.jpg';
import imgPDF1UA from './assets/1-ua.jpg';
import imgPDF2 from './assets/2.jpg';
import imgPDF2UA from './assets/2-ua.jpg';
import imgPDF3 from './assets/3.jpg';
import imgPDF3UA from './assets/3-ua.jpg';
import imgPDF3a from './assets/3a.jpg';
import imgPDF3aUA from './assets/3a-ua.jpg';
import imgPDF4 from './assets/4.jpg';
import imgPDF4UA from './assets/4-ua.jpg';
import imgPDF5 from './assets/5.jpg';
import imgPDF5UA from './assets/5-ua.jpg';
import imgPDF6 from './assets/6.jpg';
import imgPDF6UA from './assets/6-ua.jpg';
import imgPDF7 from './assets/7.jpg';
import imgPDF7UA from './assets/7-ua.jpg';
import imgPDF8 from './assets/8.jpg';
import imgPDF8UA from './assets/8-ua.jpg';

export default function () {
  return {
    imgPDF1: {
      ru: imgPDF1,
      ua: imgPDF1UA
    },
    imgPDF2: {
      ru: imgPDF2,
      ua: imgPDF2UA
    },
    imgPDF3: {
      ru: imgPDF3,
      ua: imgPDF3UA
    },
    imgPDF3a: {
      ru: imgPDF3a,
      ua: imgPDF3aUA
    },
    imgPDF4: {
      ru: imgPDF4,
      ua: imgPDF4UA
    },
    imgPDF5: {
      ru: imgPDF5,
      ua: imgPDF5UA
    },
    imgPDF6: {
      ru: imgPDF6,
      ua: imgPDF6UA
    },
    imgPDF7: {
      ru: imgPDF7,
      ua: imgPDF7UA
    },
    imgPDF8: {
      ru: imgPDF8,
      ua: imgPDF8UA
    },

    howWeCalculateScoreH1: {
      ru: 'Как мы считаем оценку',
      ua: 'Як ми рахуємо оцінку'
    },
    breadcrumbsMain: {
      ru: 'Главная',
      ua: 'Головна'
    },

    scoreMaximum: {
      ru: 'максимальный балл',
      ua: 'максимальний бал'
    },
    scoreMinimum: {
      ru: 'минимальный балл',
      ua: 'мінімальний бал'
    },
    scoreMinimumLower: {
      ru: '0 и ниже',
      ua: '0 і нижчий'
    },

    moreDetail: {
      ru: 'Подробнее',
      ua: 'Детальніше'
    },
    btnToBackText: {
      ru: 'Вернуться назад',
      ua: 'Повернутися назад'
    },
    btnToBackTitle: {
      ru: 'Назад',
      ua: 'Назад'
    },
    room: {
      ru: 'комната',
      ua: 'кімната'
    },
    parameter: {
      ru: 'параметр',
      ua: 'параметр'
    },
    parameterDeclination: {
      ru: 'параметра',
      ua: 'параметри'
    },
    parameterMultiple: {
      ru: 'параметров',
      ua: 'параметрів'
    },
    paragraph: {
      ru: 'пункт',
      ua: 'пункт'
    },
    paragraphDeclination: {
      ru: 'пункта',
      ua: 'пункти'
    },
    paragraphMultiple: {
      ru: 'пунктов',
      ua: 'пунктів'
    },

    howExpertWorksH2: {
      ru: 'Как работает эксперт',
      ua: 'Як працює експерт'
    },
    howExpertWorksAlt: {
      ru: 'Назначение земли',
      ua: 'Призначення землі'
    },

    whatsInReportH2: {
      ru: 'Что в отчёте',
      ua: 'Що у звіті'
    },
    whatsInReportH3: {
      ru: 'Документы, реестры',
      ua: 'Документи, реєстри'
    },

    analysisRegisterCourtDecisionsH2: {
      ru: 'Анализ реестра судебных решений',
      ua: 'Аналіз реєстру судових рішень'
    },

    legalAdviceContractAnalysisH2: {
      ru: 'Консультация юриста, анализ договора, налоги и сборы',
      ua: 'Консультація юриста, аналіз договору, податки та збори'
    },
    legalAdviceContractAnalysisAlt: {
      ru: 'Юридическая консультация по инвестированию ЖК',
      ua: 'Юридична консультація щодо інвестування ЖК'
    },

    reputationDeveloperH2: {
      ru: 'Репутация застройщика и ЖК',
      ua: 'Репутація забудовника та ЖК'
    },
    reputationDeveloperAlt1: {
      ru: 'Задержка сдачи по другим ЖК застройщика',
      ua: 'Затримка здачі по іншим ЖК забудовника'
    },
    reputationDeveloperAlt2: {
      ru: 'Задержка сдачи данного ЖК',
      ua: 'Затримка здачі даного ЖК'
    },
    reputationDeveloperAlt3: {
      ru: 'Главные выводы',
      ua: 'Головні висновки'
    },
    reputationDeveloperAlt4: {
      ru: 'Сводная таблица баллов',
      ua: 'Зведена таблиця балів'
    },

    blockImportantH2: {
      ru: 'Важно',
      ua: 'Важливо'
    }
  };
}
